import React, { PureComponent } from "react";

import { getStyledProps, ITabListStyledProps, TabListStyled } from "./styled";
import { Tab } from "./Tab";
import { IWithTabContextProps, withTabsContext } from "./Tabs";

export interface ITabListProps extends ITabListStyledProps, IWithTabContextProps {}

type Props = ITabListProps;

export class TabListComponent extends PureComponent<Props> {
  render() {
    const { children, activeIndex, onActivate } = this.props;
    const styledProps = getStyledProps(this.props);

    const tabs = React.Children.map(children, (child, index: number) => {
      if (React.isValidElement(child)) {
        if (child.type === Tab) {
          return React.cloneElement(child, {
            index,
            active: index === activeIndex,
            onClick: onActivate,
          });
        }
      }
      return child;
    });

    return <TabListStyled {...styledProps}>{tabs}</TabListStyled>;
  }
}

export const TabList = withTabsContext(TabListComponent);
